export const REDIRECT = 'REDIRECT';
//# sourceMappingURL=actionTypes.js.map